import { render, staticRenderFns } from "./WorkNotificationItem.vue?vue&type=template&id=4b8e6c43&scoped=true"
import script from "./WorkNotificationItem.vue?vue&type=script&lang=js"
export * from "./WorkNotificationItem.vue?vue&type=script&lang=js"
import style0 from "./WorkNotificationItem.vue?vue&type=style&index=0&id=4b8e6c43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e6c43",
  null
  
)

export default component.exports